import { render, staticRenderFns } from "./newYear.vue?vue&type=template&id=f425f6ba&scoped=true&"
import script from "./newYear.vue?vue&type=script&lang=js&"
export * from "./newYear.vue?vue&type=script&lang=js&"
import style0 from "./newYear.vue?vue&type=style&index=0&id=f425f6ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f425f6ba",
  null
  
)

export default component.exports